import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import 'bootstrap/js/tooltip';
import SearchDropdown from './components/SearchDropdown.vue';

function DonutChart(options) {
  this.settings = $.extend({
    element: options.element,
    percent: 100,
  }, options);

  this.circle = this.settings.element.find('path');
  this.circleBg = this.settings.elementBg.find('path');
  this.settings.stroke_width = parseInt(this.circle.css('stroke-width'), 10);
  this.radius = (parseInt(this.settings.element.css('width'), 10) / 1 - this.settings.stroke_width) / 2;
  this.angle = -97.5; // Origin of the draw at the top of the circle
  this.i = Math.round(0.75 * this.settings.percent);
  this.iBg = Math.round(0.75 * 100);
  this.first = true;

  this.animate = function () {
    // this.timer = setInterval(this.loop.bind(this), 10);
    this.loop();
  };

  this.loop = function loop() {
    this.angle += 5;
    this.angle %= 360;
    const radians = (this.angle / 180) * Math.PI;
    const x = this.radius + (this.settings.stroke_width / 2) + (Math.cos(radians) * this.radius);
    const y = this.radius + (this.settings.stroke_width / 2) + (Math.sin(radians) * this.radius);
    let d;
    let dBg;
    if (this.first === true) {
      if (this.i > 0) {
        d = `${this.circle.attr('d')} M ${x} ${y}`;
      }
      dBg = `${this.circleBg.attr('d')} M ${x} ${y}`;
      this.first = false;
    } else {
      if (this.i > 0) {
        d = `${this.circle.attr('d')} L ${x} ${y}`;
      }
      dBg = `${this.circleBg.attr('d')} L ${x} ${y}`;
    }
    if (this.i > 0 && d) {
      this.circle.attr('d', d);
    }
    this.circleBg.attr('d', dBg);
    this.i -= 1;
    this.iBg -= 1;

    if (this.iBg <= 0) {
      // clearInterval(this.timer);
    } else {
      this.loop();
    }
  };
}

$(() => {
  $('.donut-chart').each(function createChart(index) {
    const percent = parseInt($(this).attr('data-percent'), 10);
    $(this).append(`<svg preserveAspectRatio="xMidYMid" id="donutChartSVG${index}-bg" class="donut-chart-bg"><path d="M100,100" /></svg>`);
    $(this).append(`<svg preserveAspectRatio="xMidYMid" id="donutChartSVG${index}"><path d="M100,100" /></svg>`);
    $(this).append(`<p class="middle-text">${percent}%</p>`);
    const p = new DonutChart({
      element: $(`#donutChartSVG${index}`),
      elementBg: $(`#donutChartSVG${index}-bg`),
      percent,
    });
    p.animate();
  });
});

const app = new Vue({
  el: '#app',
  created() {
    const path = decodeURIComponent(window.location.pathname);
    const match = path.match(/\/predpisi\/([\wčšž-]+)\/$/);
    if (match && match[1]) {
      const ministryId = this.ministryIdFromSlug(match[1]);
      const ministry = this.filterMinistries.find(e => e.id === ministryId);
      if (ministry) {
        ministry.selected = true;
      }
    }
  },
  data: {
    // eslint-disable-next-line no-underscore-dangle
    violationsByMinistry: window.__violations_by_ministry__ || [],
    violationsByMinistryLastUpdate: [],
    sortKey: window.__all_acts__ ? 'id' : 'violations.percent', // eslint-disable-line no-underscore-dangle
    sortReverse: true,
    showTimeRange: 'all-time',
    filterMinistries: [
      { id: 0, label: 'Ministrstvo za demografijo, družino in socialne zadeve', abbr: 'MDDSZ' },
      { id: 1, label: 'Ministrstvo za finance', abbr: 'MF' },
      { id: 2, label: 'Ministrstvo za gospodarstvo, delo in šport', abbr: 'MGDŠ' },
      { id: 3, label: 'Ministrstvo za infrastrukturo in energetiko', abbr: 'MIE' },
      { id: 4, label: 'Ministrstvo za izobraževanje, znanost in mladino', abbr: 'MIZM' },
      { id: 5, label: 'Ministrstvo za kmetijstvo', abbr: 'MKGP' },
      { id: 6, label: 'Ministrstvo za kulturo', abbr: 'MK' },
      { id: 7, label: 'Ministrstvo za lokalno samoupravo, kohezijo in regionalni razvoj', abbr: 'MLSKRR' },
      { id: 8, label: 'Ministrstvo za notranje zadeve in javno upravo', abbr: 'MNZJU' },
      { id: 9, label: 'Ministrstvo za obrambo', abbr: 'MO' },
      { id: 10, label: 'Ministrstvo za okolje in prostor', abbr: 'MOP' },
      { id: 11, label: 'Ministrstvo za pravosodje', abbr: 'MP' },
      { id: 12, label: 'Ministrstvo za zdravje', abbr: 'MZ' },
      { id: 13, label: 'Ministrstvo za zunanje in evropske zadeve', abbr: 'MZZ' },
    ],
    filterTimeRange: [
      { id: 0, label: 'Cel mandat', selected: true },
      { id: 1, label: 'Zadnja objava' },
    ],
    filterViolationType: [
      { id: 0, label: 'Brez javne razprave' },
      { id: 1, label: 'Brez roka za pripombe' },
      { id: 2, label: 'Prekratek rok za pripombe' },
      { id: 3, label: 'Ne krši ReNDej' },
    ],
    allActs: window.__all_acts__ || [], // eslint-disable-line no-underscore-dangle
    lastUpdate: {
      start: window.__last_update_start__ ? window.__last_update_start__.split('T')[0] : '', // eslint-disable-line no-underscore-dangle
      end: window.__last_update_end__ ? window.__last_update_end__.split('T')[0] : '', // eslint-disable-line no-underscore-dangle
    },
  },
  computed: {
    sortedViolationsByMinistry() {
      if (this.showTimeRange === 'all-time') {
        if (this.violationsByMinistry) {
          let sorted = this.violationsByMinistry;
          if (this.sortKey) {
            sorted = _.sortBy(sorted, [(o) => {
              const val = _.get(o, this.sortKey);
              if (typeof val === 'string') {
                return val.toLowerCase();
              }
              return val;
            }]);
            if (this.sortReverse) {
              sorted = sorted.reverse();
            }
          }
          return sorted;
        }
        return this.violationsByMinistry;
      }
      if (this.violationsByMinistryLastUpdate) {
        let sorted = this.violationsByMinistryLastUpdate;
        if (this.sortKey) {
          sorted = _.sortBy(sorted, [(o) => {
            const val = _.get(o, this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            sorted = sorted.reverse();
          }
        }
        return sorted;
      }
      return this.violationsByMinistryLastUpdate;
    },
    filterMinistriesSelected() {
      return this.filterMinistries
        .filter(e => e.selected);
    },
    filterMinistriesPlaceholder() {
      const selected = this.filterMinistriesSelected.length;
      if (!selected || selected === this.filterMinistries.length) {
        return 'Vsa ministrstva';
      }
      return `Izbrana ministrstva: ${selected}`;
    },
    filterTimeRangeSelected() {
      return this.filterTimeRange
        .filter(e => e.selected);
    },
    filterTimeRangePlaceholder() {
      return this.filterTimeRangeSelected.length ? `${this.filterTimeRangeSelected[0].label}` : 'Izberite časovni razpon';
    },
    filterViolationTypeSelected() {
      return this.filterViolationType
        .filter(e => e.selected);
    },
    filterViolationTypePlaceholder() {
      const selected = this.filterViolationTypeSelected.length;
      if (!selected || selected === this.filterViolationType.length) {
        return 'Vse kršitve';
      }
      return `Izbrane kršitve: ${selected}`;
    },
    sortedAllActs() {
      if (this.allActs) {
        let sorted = this.allActs;
        if (this.filterMinistriesSelected.length) {
          sorted = sorted
            .filter(e => this.filterMinistriesSelected.some(v => v.id === e.ministrstvo));
        }
        if (this.filterTimeRangeSelected.length && this.filterTimeRangeSelected[0].id === 1) {
          // TODO: time range
          sorted = sorted
            .filter(e => e.datum_od >= this.lastUpdate.start);
        }
        if (this.filterViolationTypeSelected.length) {
          sorted = sorted
            .filter((e) => {
              const k = this.getViolationDisplay(e.krsitev);
              return this.filterViolationTypeSelected.some(v => v.label === k);
            });
        }
        if (this.sortKey) {
          sorted = _.sortBy(sorted, [(o) => {
            const val = _.get(o, this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            sorted = sorted.reverse();
          }
        }
        return sorted;
      }
      return this.allActs;
    },
  },
  watch: {
    showTimeRange(value) {
      if (value === 'all-time' && !this.violationsByMinistry.length) {
        this.fetchData('/stevec-krsitev/getViolationsByMinistry/', 'violationsByMinistry');
      } else if (value === 'last-update' && !this.violationsByMinistryLastUpdate.length) {
        this.fetchData('/stevec-krsitev/getViolationsByMinistryLastUpdate/', 'violationsByMinistryLastUpdate');
      }
    },
    sortedViolationsByMinistry(value, oldValue) {
      if (oldValue != null) {
        this.announceTableChanged();
      }
    },
    sortedAllActs(value, oldValue) {
      if (oldValue != null) {
        this.announceTableChanged();
      }
    },
  },
  methods: {
    announceTableChanged: _.debounce(function announceTableChanged() {
      if (typeof window != 'undefined') {
        console.log("table changed!");
        const $body = $(document.body);
        $body.append('<div class="sr-only" aria-live="polite">Vsebina tabele spremenjena.</div>');
      }
    }, 1000),
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortKey = key;
        this.sortReverse = false;
      }
    },
    fetchData(url, key) {
      $.getJSON(url).done((data) => {
        data.forEach((e) => {
          if (!_.isArray(e.countries)) {
            e.countries = [e.countries];
          }
        });
        this[key] = data;
      }).fail(() => {
        const arr = [];
        arr.error = true;
        this[key] = arr;
      });
    },
    getViolationDisplay(violation) {
      switch (violation) {
        case 'prekratek_rok':
          return 'Prekratek rok za pripombe';
        case 'brez_roka':
          return 'Brez roka za pripombe';
        case 'brez_razprave':
          return 'Brez javne razprave';
        case 'ok':
          return 'Ne krši ReNDej';
        default:
          return '';
      }
    },
    getDateDisplay(dateFrom, dateTo) {
      if (dateFrom) {
        const dateFromString = new Date(dateFrom).toLocaleDateString('sl');
        if (dateTo) {
          return `${dateFromString} - ${new Date(dateTo).toLocaleDateString('sl')}`;
        }
        return dateFromString;
      }
      return '/';
    },
    getMinistryDisplay(ministry) {
      const m = this.filterMinistries.find(e => e.id === ministry);
      if (m) {
        return m.label;
      }
      return '';
    },
    getMinistryDisplayAbbr(ministry) {
      const m = this.filterMinistries.find(e => e.id === ministry);
      if (m) {
        return m.abbr;
      }
      return '';
    },
    formatDuration(duration) {
      if (duration === 1) {
        return '1 dan';
      } else if (duration > 1) {
        return `${duration} dni`;
      }
      return '/';
    },
    slugify(string) {
      return String(string).trim().toLowerCase().replace(/[^\wčšž]+/gi, '-');
    },
    openActsForMinistry(ministry) {
      const slug = this.slugify(ministry);
      window.location.assign(`/stevec-krsitev/predpisi/${slug}/`);
    },
    ministryIdFromSlug(ministrySlug) {
      const m = this.filterMinistries.find(e => this.slugify(e.label) === ministrySlug);
      return m ? m.id : -1;
    },
  },
  directives: {
    sortarrow: {
      bind(el, binding, vnode) {
        el.sortArrowListener = () => {
          vnode.context.sortBy(binding.value);
        };
        el.addEventListener('click', el.sortArrowListener);
        el.classList.add('sortarrow');
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      update(el, binding, vnode) {
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      unbind(el) {
        el.removeEventListener('click', el.sortArrowListener);
        el.sortArrowListener = null;
      },
    },
  },
  components: {
    SearchDropdown,
  },
});

window.app = app;

$('[data-toggle="tooltip"]').tooltip({
  container: 'body',
});



// WEBPACK FOOTER //
// ./src/stevec.js